import Payment from 'payment';
import { reduxForm } from 'redux-form';
import { compose, withHandlers } from 'recompose';
import withCurrency from '../../../../common/hoc/withCurrency';

const validate = (values) => {
  const errors = {};
  if (!Payment.fns.validateCardNumber(values.number || '')) {
    errors.number = 'Invalid card number';
  }

  if (!Payment.fns.validateCardExpiry(values.exp || '')) {
    errors.exp = 'Invalid expiration date';
  }

  if (!Payment.fns.validateCardCVC(values.cvc || '')) {
    errors.cvc = 'Invalid CVC number';
  }

  return errors;
};

export default compose(
  withCurrency,
  reduxForm({
    validate,
    enableReinitialize: true,
  }),
  withHandlers({
    save: props => data => props.save(data).then(props.cancel),
  }),
);
